import { createApiClient } from '@ideight/api-client'
import { setMaterialBaseUrl, setTextureBaseUrl } from '@ideight/engine/view'

/**
 * Typed REST client for the Tinkerspace API. Use this for non-auth routes
 * (e.g. /me, /healthz, future /projects).
 *
 * `credentials: 'include'` is required because the API and the web
 * app live on different subdomains; without it the browser drops the
 * Better Auth session cookie on cross-origin fetches.
 */
const baseUrl = process.env.NEXT_PUBLIC_API_URL

if (!baseUrl) {
  throw new Error('NEXT_PUBLIC_API_URL is not set — check next.config.ts.')
}

export const api = createApiClient({
  baseUrl,
  init: { credentials: 'include' },
})

// Point the engine's texture URL resolver at the API origin so
// `getTextureUrl('oak')` returns the absolute worker URL that fronts
// R2. Side-effecting at module load (same trick the auth client uses)
// — every page that imports `api` from this module gets the binding
// for free.
setTextureBaseUrl(baseUrl)

// PR-3 catalog material URLs come from the API worker — same origin
// as textures + assets. The web app's `ConnectedFloorplan` calls
// `api.listMaterials()` on editor mount and registers the result via
// `setCatalogMaterials`; the engine's `getMaterialChannelUrl` then
// builds `<API>/materials/{id}/{channel}.{ext}` URLs that hit the
// proxy route serving the R2 mirror.
setMaterialBaseUrl(baseUrl)
